import { gql } from "@apollo/client";

export const GET_PRODUCTS = gql`
  query Products(
    $vestiging_id: Int!
    $id: [Int]
    $naam: String
    $is_option: Boolean
    $idNaamApiId1: String
    $parentOptionGroupIds: QueryProductsHasOptionGroupProductWhereHasConditions
    $pageSize: Int
    $page: Int
  ) {
    products(
      vestiging_id: $vestiging_id
      id: $id
      naam: $naam
      isOption: $is_option
      idNaamApiId1: $idNaamApiId1
      first: $pageSize
      page: $page
      hasOptionGroupProduct: $parentOptionGroupIds
    ) {
      data {
        id
        naam
        vestiging_id
        sortkey
        apiId1
        apiId2
        blocked
        is_actief
        prijs
      }
      paginatorInfo {
        perPage
        currentPage
        total
      }
    }
  }
`;
